module.exports = __webpack_public_path__ + "static/img/q_6-2.6ae6394.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/q_6-2.png
// module id = 7RqC
// module chunks = 0